import { API } from '../../../../config';
import { errorHandler } from '../../auth/errorAction';

export const unmountListCountries = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_COUNTRIES'})
}

export const unmountDetailCountries = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_COUNTRIES'})
}

export const unmountMasterCountries = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_COUNTRIES'})
}

export const listCountries = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_COUNTRIES' })
  return API.GET('/country/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_COUNTRIES_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_COUNTRIES_FAILED' }), 
    ))
  })
}

export const detailCountries = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_COUNTRIES' })
  const params = {
    'id': id
  }
  API.GET('/country/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_COUNTRIES_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_COUNTRIES_FAILED' }), 
      ))
    )
  })
}

export const masterCountries = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_COUNTRIES' })
  return API.GET('/country/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_COUNTRIES_SUCCESS', 
      payload: { data: response.data }
    })
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_COUNTRIES_FAILED' }), 
    ))
  })
}

export const createCountries = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/country/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editCountries = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/country/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableCountry = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/country/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableCountry = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/country/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}